import { batch, untrack } from "solid-js";
import { SetStoreFunction, Store } from "solid-js/store";

type StorePair<T> = [Store<T>, SetStoreFunction<T>];

namespace StorePair {
  export const safeSetter = <T,>([store, setStore]: StorePair<T>) =>
    ((...args: any[]) => {
      batch(() => {
        const value = args.pop();

        untrack(function createParents(current: any = store, i = 0) {
          if (i === args.length - 1) return;

          if (current[args[i]] == null) {
            // @ts-expect-error
            setStore(...args.slice(0, i + 1), {});
          }

          createParents(current[args[i]], i + 1);
        });

        // @ts-expect-error
        setStore(...args, value);
      });
    }) as SetStoreFunction<T>;

  export const at = <T,>(
    [store, setStore]: StorePair<T>,
    key: keyof T
  ): StorePair<T[typeof key]> =>
    [
      store[key],
      (...args: any[]) =>
        // @ts-expect-error
        setStore(key, ...args),
    ] as const;
}

export default StorePair;
